import styled from 'styled-components';
import { colors } from '../styles/variables';

const InventoryIconView = styled.a`
  display: block;
  position: relative;
  cursor: pointer;
  width: 40px;
  height: 40px;
  transition: all 0.2s ease-in-out;
  img {
    width: 40px;
  }
  .badge {
    position: absolute;
    top: 0;
    right: 0;
    background-color: ${colors.red};
    color: ${colors.white};
    font-weight: bold;
    width: 24px;
    height: 24px;
    border-radius: 12px;
    line-height: 24px;
    text-align: center;
    padding: 0;
  }
  &:hover {
    opacity: 0.7;
  }
`;

export default InventoryIconView;
